import { render, staticRenderFns } from "./BasePopoverIcon.vue?vue&type=template&id=3b1e2632"
import script from "./BasePopoverIcon.vue?vue&type=script&lang=js"
export * from "./BasePopoverIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports